<template>
    <el-form label-width="80px" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="用户ID" required>
            <el-input v-model="form.id" clearable disabled />
        </el-form-item>
        <el-form-item label="当前邀请码" required>
            <el-input v-model="form.current_invite" clearable disabled />
        </el-form-item>
        <el-form-item label="新邀请码" required>
            <el-input v-model="form.invite" clearable placeholder="请输入新的邀请码" />
        </el-form-item>
    </el-form>
</template>

<script setup>
import { reactive } from 'vue'

const form = reactive({
    id: '',
    current_invite: '',
    invite: ''
})

defineExpose({form})
</script>

<style lang="less" scoped>
.demo-form-inline .el-input {
    --el-input-width: 220px;
}

.form-title {
    width: 100%;
    margin: 20px 0 10px 0;
    color: #333;
    font-size: 16px;
    font-weight: bold;
}
</style>